import logo from "@/assets/logo-small.png";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa6";
import { trackPhoneClick, trackEmailClick } from "@/lib/analytics";
import { openConsentSettings } from "@/lib/consent";
import { Link } from "@/lib/router-compat";
import { BUSINESS } from "@/lib/business";

const footerLinks = [
  { to: "/", label: "Startseite" },
  { to: "/foto", label: "Fotografie" },
  { to: "/film", label: "Videoproduktion" },
  { to: "/socialmedia", label: "Social Media" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/blog", label: "Blog" },
  { to: "/termin", label: "Termin buchen" },
];

const legalLinks = [
  { to: "/impressum", label: "Impressum" },
  { to: "/datenschutz", label: "Datenschutz" },
  { to: "/agb", label: "AGB" },
];

// Plain links to our own profiles: no embedded plugins, nothing is sent before a click.
const socialLinks = [
  { href: "https://www.instagram.com/clicksdmp/", label: "Instagram", Icon: FaInstagram },
  { href: "https://www.facebook.com/clicksdmp", label: "Facebook", Icon: FaFacebookF },
  { href: "https://www.tiktok.com/@clicksdmp", label: "TikTok", Icon: FaTiktok },
];

const linkClass = "text-sm text-muted-foreground hover:text-foreground transition-colors";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border py-12">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-3">
            <img src={logo} alt="Clicks Design & Media Production" className="h-12 w-auto" />
            <div className="flex items-center gap-3">
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  title={label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors"
                >
                  <Icon className="h-4 w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <div className="text-center md:text-right">
            <div className="flex flex-wrap gap-4 justify-center md:justify-end mb-2">
              {legalLinks.map((l) => (
                <Link key={l.to} to={l.to} className={linkClass}>
                  {l.label}
                </Link>
              ))}
              <button type="button" onClick={openConsentSettings} className={linkClass}>
                Cookie-Einstellungen
              </button>
            </div>
            <p className="text-sm text-muted-foreground mb-2">
              <a
                href="tel:+4917670027200"
                className="hover:text-foreground transition-colors"
                onClick={() => trackPhoneClick()}
              >
                +49 176 700 27 200
              </a>
              <span className="mx-2" aria-hidden="true">
                ·
              </span>
              <a
                href="mailto:info@clicksdmp.com"
                className="hover:text-foreground transition-colors"
                onClick={() => trackEmailClick()}
              >
                info@clicksdmp.com
              </a>
            </p>
            <p className="text-sm text-muted-foreground mb-2">{BUSINESS.openingHoursText}</p>
            <p className="text-sm text-muted-foreground">
              © {year} Clicks DMP – Design & Media Production. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
        <nav aria-label="Footer-Navigation" className="mt-8 pt-6 border-t border-border/50">
          <ul className="flex flex-wrap gap-x-6 gap-y-2 justify-center md:justify-start">
            {footerLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className={linkClass}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
